<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr :btitle="'Config the Tcont Reference'" style="height: 410px">
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkAdd()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllTcont"
                />
                <label for="idSelectAllTcont"></label>
              </th>
              <th
                v-for="(value, key) in uniqueTcontTable.title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in uniqueTcontTable.data"
              :key="row.tcont"
              :class="{ 'true:': true }"
              @click=""
            >
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectTcont' + index"
                  />
                  <label :for="'idRowSelectTcont' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.tcont }}</div>
              </td>
              <td>
                <div>{{ row.dbaProfile }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Tcont Edit'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="tcont"
                  >Tcont ID</label
                >
                <div class="col-sm-5" :class="{ 'has-error': checkTcont() }">
                  <input
                    type="text"
                    class="form-control"
                    id="tcont"
                    v-model="tcontForm.tcont"
                    placeholder="INTEGER<1-8>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkTcont() ? 'block' : 'none',
                    }"
                    >{{ checkTcont() }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="dbaprofile"
                  >DBA Profile</label
                >
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="dbaprofile"
                    v-model="tcontForm.dbaProfile"
                  >
                    <option
                      v-for="data in dbaTable"
                      :key="data.profileId"
                      :value="data.profileId"
                    >
                      {{ data.profileId + ":" + data.profileName }}
                    </option>
                  </select>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"

export default {
  name: "uniqueTcont",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  props: ["uniqueOnt"],

  data() {
    return {
      uniqueTcontTable: "",
      isShowAddTable: false,
      isSelectAll: false,
      iBox: {},
      dbaTable: "",
      tcontForm: {
        tcont: "",
        dbaProfile: "",
      },
    }
  },

  created() {
    this.loaduniqueTcont()
    this.loaddbaProfile()
  },

  methods: {
    loaduniqueTcont() {
      get("uniqueTcont?ontIndex=" + this.uniqueOnt)
        .then((res) => (this.uniqueTcontTable = res.data))
        .catch((err) => {
          this.uniqueTcontTable = en.uniqueTcontTable
        })
    },

    loaddbaProfile() {
      get("profiledba")
        .then((res) => {
          this.dbaTable = res.data.data
        })
        .catch((err) => {})
    },

    clkAdd() {
      this.isShowAddTable = true
      this.resetField()
      this.selectNull()
    },

    clkDel() {
      var delData = {}
      var list = []

      for (let i = 0; i < this.uniqueTcontTable.data.length; i++) {
        if (this.uniqueTcontTable.data[i].selected) {
          list.push({ tcont: Number(this.uniqueTcontTable.data[i].tcont) })
        }
      }
      if (list.length == 0) {
        return
      }

      delData["ontid"] = this.uniqueOnt
      delData["tcontList"] = list
      post("uniqueTcontDelete", delData)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loaduniqueTcont()
            this.showAlertBox("info", "Info", "Delete Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },
    clkCancel() {
      this.isShowAddTable = false
      console.log(this.isShowAddTable)
    },

    resetField() {
      var tcontformTmp = {
        tcont: "",
        dbaProfile: "",
      }
      this.tcontForm = tcontformTmp
    },
    changeSelectAll() {
      for (let i = 0; i < this.uniqueTcontTable.data.length; i++) {
        if (this.isSelectAll) {
          this.uniqueTcontTable.data[i].selected = true
        } else {
          this.uniqueTcontTable.data[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.uniqueTcontTable.data.length; i++) {
        this.uniqueTcontTable.data[i].selected = false
      }
      this.isSelectAll = false
    },
    clkApply() {
      var newTcont = {
        ontid: this.uniqueOnt,
        tcont: Number(this.tcontForm.tcont),
        dbaProfile: Number(this.tcontForm.dbaProfile),
      }
      for (let i = 0; i < this.uniqueTcontTable.data.length; i++) {
        if (newTcont.tcont == this.uniqueTcontTable.data[i].tcont) {
          this.showAlertBox("warn", "Message", "This tcont has been created")
          return
        }
      }

      if (this.tcontForm.tcont == "" || this.tcontForm.dbaProfile == "") {
        this.showAlertBox("warn", "Message", "Invalid parameters")
        return
      }
      if (this.checkTcont()) {
        this.showAlertBox("warn", "Message", "Invalid tcont")
        return
      }

      post("uniqueTcontConfig", newTcont)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loaduniqueTcont()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
      this.selectNull()
    },
    checkTcont() {
      if (this.tcontForm.tcont != "") {
        let tcont = Number(this.tcontForm.tcont)
        if (!isNaN(tcont)) {
          if (tcont < 1 || tcont > 8) return "tcont must be in range 1-8"
        } else return "tcont must be in range 1-8"
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
